import { TextInfo } from '../../../components/text'
import { LoanTypeEnum } from '../../../models/enum/loan-type.enum';
import { Helpers } from '../../../utils/helper';
import { P2TextInput } from 'react-bootstrap-common-script';
import React, { useCallback, useMemo, useState } from 'react';

interface CurrentLoadSegmentProps {
  loan_type?: LoanTypeEnum;
  loan_outstanding_amount?: string;
  loan_created_date?: string;
  setOnCurrencyChange?: (e: string) => void;
  title?: JSX.Element;
  isDisabled?: boolean
}

const getLoanTypeTitle = (loanType?: LoanTypeEnum) => {
    switch(loanType){
      case LoanTypeEnum.hdb_loan:
        return "HDB Loan";
      case LoanTypeEnum.bank_loan:
        return "Bank Loan";
      default: 
        return "No Loan";
    }
}

function CurrentLoadSegment({ ...props }: CurrentLoadSegmentProps) {
  const [isDisplayingDefault, setIsDisplayingDefault] = useState(true);

  const outstandingLoanAmount = useMemo(() => {
    try{
      if (props.loan_outstanding_amount?.toString() === "0") {
        return "$ 0.00";
      } else {
        if (isDisplayingDefault) {
          return Helpers.formatThousandSeparator(Helpers.formatCurrencyInput(props.loan_outstanding_amount?.toString() ?? "0", true), "$ ");
        } else {
          return Helpers.formatThousandSeparator(props.loan_outstanding_amount?.toString(), "$ ");
        }
      }
    } catch(e){
      return "$ 0.00";
    }
  }, [props.loan_outstanding_amount, isDisplayingDefault])

  const loan_type_title = getLoanTypeTitle(props.loan_type);
  
  const handleOnBlur = useCallback((e:any)=> {
    if (e) {
      let value = Helpers.formatCurrencyInput(e, true);
      if (props.setOnCurrencyChange) {
        props.setOnCurrencyChange(value);
      }
    }
  },[props])

  const handleOnChange = useCallback((e: string) => {
    setIsDisplayingDefault(false);
    if (props.setOnCurrencyChange) {
      props.setOnCurrencyChange(e);
    }
    let value = Helpers.formatCurrencyInput(e, false);
    if (props.setOnCurrencyChange) {
      props.setOnCurrencyChange(value);
    }
  },[props])

  return (
    <div className='polymer-current-loan-segment'>
      {props.title}
      <div className='polymer-current-loan-segment__info'>
        <TextInfo title='Current Loan Type:' description={<div><p className='m-0'>{loan_type_title}</p></div>} />
        {props.loan_type === LoanTypeEnum.hdb_loan && <TextInfo title='Current Outstanding Loan:' description={
          <div>
            <p className='m-0'>{props.loan_outstanding_amount ? Helpers.formatThousandSeparator(props.loan_outstanding_amount,"$ "): "$ 0.00"}</p>
            {props.loan_created_date && <p className='m-0'>As at {Helpers.formatDate(props.loan_created_date)}</p>}
          </div>} />}
        {props.loan_type === LoanTypeEnum.bank_loan && <div>
          <P2TextInput disabled={props.isDisabled ?? false} hasTooltip tooltipContent={"You can obtain the outstanding bank mortgage loan amount from your latest bank statement."} isError={false} errorMsg={""} maxLength={30} required value={outstandingLoanAmount} name='outstanding_loan_amount' label={"Current Outstanding Loan"} type='text' 
          onBlur={handleOnBlur} onChange={handleOnChange} />
        </div>
        }
      </div>
    </div>
  )
}

export default CurrentLoadSegment